import React from 'react';

interface LoaderProps {
  size?: number;
  borderWidth?: number;
  color?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  size = 25,
  borderWidth = 3,
  color = '#000',
}) => {
  return (
    <span
      className="loader inline-block animate-spin rounded-full"
      style={{
        width: size,
        height: size,
        borderWidth,
        borderStyle: 'solid',
        borderColor: `${color}`,
        borderTopColor: 'transparent',
      }}
    />
  );
};
